<template>
  <div class="client-container">
    <a-table
      :pagination="showPagination"
      :columns="tableColumns"
      :dataSource="tableDataList"
      :rowSelection="rowSelection"
      :scroll="{ x: 750, y: 450 }"
    ></a-table>

    <a-button
      @click.stop="closeWin"
      type="dashed"
      :style="{
        width: '200px',
        height: '40px',
        margin: '15px 10px 0px'
      }"
    >
      取 消
    </a-button>
    <a-button
      @click.stop="bindArea"
      type="primary"
      :style="{
        width: '200px',
        height: '40px',
        margin: '15px 10px 0px'
      }"
    >
      绑 定
    </a-button>
  </div>
</template>
<script>
var num = 0;
var pageContext;
export default {
  name: "AreaList",
  props: {
    itemData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    layerid: {
      type: String,
      default: ""
    },
    lydata: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showPagination: false,
      tableColumns: [
        {
          title: "名称",
          dataIndex: "name",
          key: "name"
        },
        {
          title: "编号",
          dataIndex: "id",
          key: "id",
          width: "180px"
        },
        {
          title: "排序",
          dataIndex: "sort",
          key: "sort",
          width: "100px"
        }
      ],
      tableDataList: [],
      selectRowKeyList: [],
      rowSelection: {
        type: "radio",
        onChange: (selectedRowKeys, selectedRows) => {
          pageContext.selectRowKeyList = selectedRowKeys;
        },
        getCheckboxProps: record => {
          return {
            props: {
              defaultChecked: pageContext.selectRowKeyList.includes(record.id)
            }
          };
        }
      }
    };
  },
  mounted() {
    pageContext = this;
    pageContext.selectRowKeyList = pageContext.itemData.area_bind;
    pageContext.refreshDataList();
  },
  methods: {
    async refreshDataList() {
      pageContext.$http
        .post("/area/getDataList", {
          platform_type: pageContext.itemData.platform_type,
          company_id: pageContext.itemData.company_id
        })
        .then(function(response) {
          if (response.data.status === 1) {
            pageContext.tableDataList = response.data.data.data_list;
          }
        })
        .catch(function(error) {
          pageContext.$message.error("请求异常，请检查");
          console.log(error);
        });
    },
    async bindArea() {
      pageContext.$http
        .post("/ManagerMg/bindArea", {
          id: pageContext.itemData.id,
          area_bind: pageContext.selectRowKeyList
        })
        .then(function(response) {
          if (response.data.status === 1) {
            pageContext.$parent.refreshDataList();
            pageContext.$message.success(response.data.msg);
            pageContext.$layer.close(pageContext.layerid);
          }
        })
        .catch(function(error) {
          pageContext.$message.error("请求异常，请检查");
          console.log(error);
        });
    },
    closeWin() {
      pageContext.$message.info("操作取消");
      pageContext.$layer.close(pageContext.layerid);
    }
  }
};
</script>
<style lang="scss" scoped>
.client-container {
  width: 100%;

  .ant-btn-circle {
    margin: 0px 5px;
  }
}
</style>
